import React from 'react';

import PropTypes from 'prop-types';

import { Table, Type } from '@nerdwallet/currency';

import style from './property-tax-table.module.less';

const columns = [
  {
    id: 'name',
    heading: 'County',
  },
  {
    id: 'propertyTaxRate',
    heading: 'Avg. property tax rate',
  },
  {
    id: 'medianHousingValue',
    heading: 'Avg. home value',
  },
];

const PropertyTaxTable = ({ counties, stateName }) => {
  if (!counties) return null;
  return (
    <div className={style.container}>
      <Type size={3} component="h3" bold className={style.heading}>
        {`Average property tax in ${stateName} counties`}
      </Type>
      <Type className={style.copy}>
        {`Taking U.S. Census data,
        NerdWallet has crunched the numbers to help you understand what
        property tax rate you can expect to pay on your future home in
        ${stateName}. Because assessed values aren’t frequently updated, you may
        pay a higher rate at first but eventually you’ll pay a similar rate.`}
      </Type>
      <div className={style['property-tax-table-wrapper']}>
        <Table
          columns={columns}
          data={counties}
          className={style['property-tax-table']}
        />
      </div>
      <Type className={style.caption} size={1}>
        Source: American Communities Survey 2016, U.S. Census
      </Type>
    </div>
  );
};

PropertyTaxTable.propTypes = {
  counties: PropTypes.array.isRequired,
  stateName: PropTypes.string.isRequired,
};

export default PropertyTaxTable;
